import { render, staticRenderFns } from "./vendorList.vue?vue&type=template&id=31aa28b3&"
import script from "./vendorList.vue?vue&type=script&lang=js&"
export * from "./vendorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports